import { render, staticRenderFns } from "./free.page.vue?vue&type=template&id=fe6ba0d8&"
import script from "./free.page.vue?vue&type=script&lang=js&"
export * from "./free.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports